import { Outlet, useLocation } from "react-router";
import { AppShell } from "@mantine/core";
import Header from "../Header";
import Nav from "../Menu";

export default () => {
  const { pathname } = useLocation();
  const userInfo = localStorage.getItem("userInfo");

  if (!userInfo || userInfo == "undefined") {
    return null;
  }

  if (
    pathname == "/onboarding" ||
    pathname == "/pricing" ||
    pathname.includes("payment")
  ) {
    return <Outlet />;
  }

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 200,
        breakpoint: "sm",
      }}
    >
      <AppShell.Header withBorder={false}>
        <Header />
      </AppShell.Header>
      <AppShell.Navbar zIndex={90} withBorder={false}>
        <Nav />
      </AppShell.Navbar>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};
